var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudygroupGridBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 905,
    height: 470,
    viewBox: "0 0 905 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 221.5,
    y1: 470,
    x2: 221.5,
    stroke: "#191A51"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 284.5,
    y1: 470,
    x2: 284.5,
    stroke: "#191A51"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 345.5,
    y1: 470,
    x2: 345.5,
    stroke: "#191A51"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 409.5,
    y1: 470,
    x2: 409.5,
    stroke: "#191A51"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 469.5,
    y1: 470,
    x2: 469.5,
    stroke: "#191A51"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 533.5,
    y1: 470,
    x2: 533.5,
    stroke: "#191A51"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 594.5,
    y1: 470,
    x2: 594.5,
    stroke: "#191A51"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 658.5,
    y1: 470,
    x2: 658.5,
    stroke: "#191A51"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 734.5,
    y1: 470,
    x2: 734.5,
    stroke: "#191A51"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 798.5,
    y1: 470,
    x2: 798.5,
    stroke: "#191A51"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 92.5,
    y1: 470,
    x2: 92.5,
    stroke: "#191A51"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 156.5,
    y1: 470,
    x2: 156.5,
    stroke: "#191A51"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 429.5,
    x2: 0.0000141859,
    y2: 429.5,
    stroke: "#191A51"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 369.5,
    x2: 0.0000141859,
    y2: 369.5,
    stroke: "#191A51"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 305.5,
    x2: 0.0000141859,
    y2: 305.5,
    stroke: "#191A51"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 244.5,
    x2: 0.0000141859,
    y2: 244.5,
    stroke: "#191A51"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 180.5,
    x2: 0.0000141859,
    y2: 180.5,
    stroke: "#191A51"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 104.5,
    x2: 0.0000141859,
    y2: 104.5,
    stroke: "#191A51"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 40.5,
    x2: 0.0000141859,
    y2: 40.5,
    stroke: "#191A51"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudygroupGridBackground);
export default __webpack_public_path__ + "static/media/studygroup-grid-background.3b83d6e68e4619381cfff6aa95758477.svg";
export { ForwardRef as ReactComponent };